import { EAgentType } from '../../types/recommendations';
export var getAgentType = function getAgentType(agentType, agentLabel) {
  if (typeof agentLabel === 'string') {
    return agentLabel;
  }
  return agentType === EAgentType.Builder ? 'Застройщик' : 'Агентство недвижимости';
};